<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__gamerankblack}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="用户账号">
          <el-input v-model="dataForm.account" placeholder="请输入用户账号" clearable></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
                  v-model="dataForm.startTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="开始时间"
          ></el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
                  v-model="dataForm.endTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="queryDataList()">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column fixed type="index" label="序号" :index="indexMethod" width="80"></el-table-column>
        <el-table-column prop="account" label="用户账号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center"></el-table-column>
        <el-table-column label="操作" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button
                    type="text" size="small"  @click="deleteHandle(scope.row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from './import/view-module'
import Url from '@/views/crs/util/url'
export default {
  mixins: [mixinViewModule],
  props:['gameRankId'],
  watch:{
    gameRankId:{
      handler(val){
        if(val){
          this.dataForm.gameRankId = val
        }
      },
      immediate:true
    }
  },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: Url.gameRank.base+'/activity/gameRankBlack/page',
        getDataListIsPage: true,
        deleteURL: Url.gameRank.base+'/activity/gameRankBlack',
        deleteIsBatch: true
      },
      dataForm: {
        gameRankId: '',
        account: "",
        startTime: "",
        endTime: ""
      }
    }
  },
  methods:{
     indexMethod(index) {
      return ++index;
    },
  },
  created() {
    this.queryDataList();
  }
}
</script>
